export enum CampaignSection {
  TOP = 'campaign-top',
  REWARDS = 'campaign-rewards',
  FORM = 'form',
  FOOTER = 'campaign-footer',
}
